import type { PersistenceOptions } from 'pinia-plugin-persistedstate'

/**
 * @description Pinia 持久化配置（白名单）
 * @param key storage key
 * @param paths 需要持久化的 state 字段（不传则持久化整个 state）
 */
const piniaPersistConfig = (key: string, paths: string[] = []): PersistenceOptions => {
  return {
    key,
    storage: window.localStorage,
    // pinia-plugin-persistedstate v4 白名单选项为 pick（v3 的 paths 已废弃，传入会被忽略导致全量持久化）
    ...(paths.length ? { pick: paths } : {})
  }
}

export default piniaPersistConfig
